import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const RateCardForm = (props) => {
  const frmRef = useRef({});
  const [cropVarietyData, setCropVarietyData] = useState([]);
  const [croptypeId, setCroptypeId] = useState([]);
  const [cropId, setCropId] = useState([]);
  // const [varietyId, setVarietyId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [cropTypeList, setCropTypeList] = useState([]);
  const [orgConfigList, setOrgConfigList] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [cropFilterList, setCropFilterList] = useState([]);

  const isConfigActive =
    orgConfigList?.length > 0 && orgConfigList[0].status === 1;

  const cropTypeOnchangedHandler = (event) => {
    var croptype = event.target.value;
    setCroptypeId(croptype);
    setCropFilterList([]);

    const cropFilterList = cropList.filter(
      (item) => parseInt(item.croptypeId) === parseInt(croptype)
    );

    setCropFilterList(cropFilterList);
  };

  const [varietyFilterList, setvarietyFilterList] = useState([]);

  const cropOnchangedHandler = (event) => {
    var crop_Id = event.target.value;
    setCropId(event.target.value);
    var varietyLis = cropVarietyData.filter((item) => item.cropId == crop_Id);
    setvarietyFilterList(varietyLis);
  };

  const { sendRequest: getcropType } = useHttp();
  useEffect(() => {
    getcropType(
      {
        url: "/api/croptypes/",
      },
      (res) => {
        if (res) {
          setCropTypeList(res.data || res);
        }
      }
    );
  }, [getcropType]);

  const { sendRequest: getOrgConfig } = useHttp();
  useEffect(() => {
    getOrgConfig(
      {
        url: `/api/orgconfigapplications?orgId=${localStorage.getItem(
          "orgId"
        )}&orgConfigSettingId=16`,
      },
      (res) => {
        if (res) {
          setOrgConfigList(res);
        }
      }
    );
  }, [getOrgConfig]);

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  }, [getcrop]);

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        if (res) {
          setCropVarietyData(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          var unitFilter = res.filter((item) => item.unitTypeId == 2);
          setUnitList(unitFilter);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: postRateCard } = useHttp();

  // const rateCardsubmitHandler = (e) => {
  //   e.preventDefault();

  //   const data = {
  //     varietyId: varietyId,
  //     class1Rate: frmRef.current.class1Rate.value.trim(),
  //     class2Rate: frmRef.current.class2Rate.value.trim(),
  //     class3Rate: isConfigActive ? 0 : frmRef.current.class3Rate.value.trim(),
  //     class4Rate: isConfigActive ? 0 : frmRef.current.class4Rate.value.trim(),
  //     bonusRate: frmRef.current.bonusRate.value.trim(),
  //     scoreLimit: frmRef.current.scoreLimit.value.trim(),
  //     quantity: 1, // frmRef.current.quantity.value.trim(),
  //     unitId: unitId,
  //     status: 1,
  //     orgId: parseInt(localStorage.getItem("orgId")),
  //     createdBy: parseInt(localStorage.getItem("id")),
  //     createdDate: new Date(),
  //   };
  //   console.log(data);
  //   postRateCard(
  //     {
  //       url: "/api/grade/",
  //       method: "POST",
  //       body: data,
  //     },
  //     (data) => {
  //       toast.success(`Rate card detail added`);
  //       props.addForm(false);
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // };

  const rateCardsubmitHandler = (e) => {
    e.preventDefault();

    const class1Rate = parseFloat(frmRef.current.class1Rate.value.trim()) || 0;
    const class2Rate = parseFloat(frmRef.current.class2Rate.value.trim()) || 0;
    const class3Rate = isConfigActive
      ? 0
      : parseFloat(frmRef.current.class3Rate.value.trim()) || 0;
    const class4Rate = isConfigActive
      ? 0
      : parseFloat(frmRef.current.class4Rate.value.trim()) || 0;
    const bonusRate = parseFloat(frmRef.current.bonusRate.value.trim()) || 0;

    if (class1Rate < 0) {
      toast.error("Good rate (Class 1) cannot be negative. Please enter a positive value.");
      return;
    }

    if (
      class1Rate === 0 &&
      class2Rate === 0 &&
      class3Rate === 0 &&
      class4Rate === 0 &&
      bonusRate === 0
    ) {
      toast.error("At least one rate value must be greater than zero.");
      return;
    }

    const data = {
      // varietyId: varietyId,
      cropId: frmRef.current.cropId.value,
      class1Rate,
      class2Rate,
      class3Rate,
      class4Rate,
      bonusRate,
      scoreLimit: frmRef.current.scoreLimit.value.trim(),
      quantity: 1,
      unitId: unitId,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
      serviceId: props.sId,
    };

    console.log(data);

    postRateCard(
      {
        url: "/api/grade/",
        method: "POST",
        body: data,
      },
      () => {
        toast.success(`Rate card detail added`);
        props.addForm(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };



  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={rateCardsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Buy Back Price</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Type</label>

                        <select
                          id="cropTypeNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropTypeNameId"] = el)}
                          value={croptypeId}
                          onChange={cropTypeOnchangedHandler}
                        >
                          <option value="">Select Crop Type</option>
                          {cropTypeList &&
                            cropTypeList.map((x) => (
                              <option
                                key={x.croptypeId}
                                value={x.croptypeId}
                              >
                                {x.cropTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Name </label>
                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropId"] = el)}
                          value={cropId}
                          onChange={cropOnchangedHandler}
                          required
                        >
                          <option value="">Select Crop</option>
                          {cropFilterList &&
                            cropFilterList.map((x) => (
                              <option
                                key={x.cropId}
                                crop-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="form-group">
                        <label>Variety Name </label>
                        <select
                          id="varietyId"
                          className="form-control"
                          ref={(el) => (frmRef.current["varietyId"] = el)}
                          value={varietyId}
                          onChange={(e) => {
                            setVarietyId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Variety</option>
                          {varietyFilterList &&
                            varietyFilterList.map((x) => (
                              <option
                                key={x.varietyId}
                                variety-id={x.varietyId}
                                value={x.varietyId}
                              >
                                {x.varietyName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div> */}
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Quantity </label>

                        <input
                          type="text"
                          id="quantity"
                          className="form-control"
                          defaultValue={1}
                          ref={(el) => (frmRef.current["quantity"] = el)}
                          autoComplete="off"
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit </label>

                        <select
                          id="unitId"
                          className="form-control"
                          ref={(el) => (frmRef.current["unitId"] = el)}
                          value={unitId}
                          onChange={(e) => {
                            setUnitId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Unit</option>
                          {unitList &&
                            unitList.map((x) => (
                              <option
                                key={x.unitId}
                                unit-id={x.unitId}
                                value={x.unitId}
                              >
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Currency </label>
                        <input
                          type="text"
                          id="currency"
                          className="form-control"
                          value={localStorage.getItem("currencyCode") || ""}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          {isConfigActive
                            ? "Good (Rate/Unit)"
                            : "Class 1 (Rate/Unit)"}
                        </label>
                        <input
                          type="number"
                          id="class1Rate"
                          className="form-control"
                          ref={(el) => (frmRef.current["class1Rate"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          {isConfigActive
                            ? "Bad (Rate/Unit)"
                            : "Class 2 (Rate/Unit)"}
                        </label>
                        <input
                          type="number"
                          id="class2Rate"
                          className="form-control"
                          ref={(el) => (frmRef.current["class2Rate"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    {!isConfigActive && (
                      <>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Class 3 ( Rate/Unit)</label>
                            <input
                              type="number"
                              id="class3Rate"
                              className="form-control"
                              ref={(el) => (frmRef.current["class3Rate"] = el)}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>Class 4 ( Rate/Unit)</label>
                            <input
                              type="number"
                              id="class4Rate"
                              className="form-control"
                              ref={(el) => (frmRef.current["class4Rate"] = el)}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {/* </div> */}

                    {/* <div className="row"> */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          {isConfigActive
                            ? "Bonus Rate(Good)"
                            : "Bonus Rate(Class 1)"}
                        </label>
                        <input
                          type="number"
                          id="bonusRate"
                          className="form-control"
                          ref={(el) => (frmRef.current["bonusRate"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          {isConfigActive
                            ? "Score Limit(Good)"
                            : "Score Limit(Class 1)"}
                        </label>
                        <input
                          type="number"
                          id="scoreLimit"
                          className="form-control"
                          ref={(el) => (frmRef.current["scoreLimit"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default RateCardForm;
